'use client';
import React, { useState } from 'react';
import Link from 'next/link';

export default function Navbar() {
  const [mobileSearchOpen, setMobileSearchOpen] = useState(false);

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-gray-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-3 md:px-8 h-14 md:h-16 flex items-center gap-2 md:gap-4">
        {/* Logo */}
        <Link href="/" className="flex items-center shrink-0 group">
          <img
            alt="Big Basket Logo"
            className="h-8 md:h-10 transition-transform duration-200 group-hover:scale-105"
            src="https://boxbasket.vercel.app/assets/logo-0Uqv8tyd.png"
          />
        </Link>

        {/* Desktop Search */}
        <div className="hidden md:flex flex-1 items-center gap-2.5 bg-gray-100 rounded-xl px-4 h-10 border-2 transition-all duration-200 border-transparent hover:border-gray-300">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="shrink-0 transition-colors text-gray-400" aria-hidden="true">
            <path d="m21 21-4.34-4.34" />
            <circle cx="11" cy="11" r="8" />
          </svg>
          <input
            placeholder='Search "atta, milk, eggs..."'
            className="bg-transparent outline-none text-sm text-gray-800 placeholder-gray-400 w-full font-medium"
            type="text"
          />
        </div>

        {/* Mobile Search Toggle */}
        <button
          className="md:hidden ml-auto p-2 rounded-xl text-gray-600 hover:text-[#0c831f] hover:bg-gray-100 transition-all"
          aria-label="Search"
          onClick={() => setMobileSearchOpen(!mobileSearchOpen)}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="m21 21-4.34-4.34" />
            <circle cx="11" cy="11" r="8" />
          </svg>
        </button>

        {/* Cart */}
        <Link
          href="/my-order"
          className="relative flex items-center gap-1.5 shrink-0 font-bold px-3 md:px-4 h-9 rounded-xl border-2 transition-all duration-200 active:scale-95 border-[#0c831f] text-[#0c831f] hover:bg-[#0c831f] hover:text-white"
        >
          <img
            alt="Cart"
            className="h-4 w-4 md:h-5 md:w-5 object-contain transition-all"
            src="https://boxbasket.vercel.app/assets/shopping-cart-cRrvgLyv.png"
          />
          <span className="hidden md:inline text-sm">My Cart</span>
        </Link>
      </div>

      {/* Mobile Search Dropdown */}
      <div className={`md:hidden overflow-hidden transition-all duration-300 ease-out ${mobileSearchOpen ? 'max-h-20 opacity-100' : 'max-h-0 opacity-0'}`}>
        <div className="px-3 pb-3 pt-1">
          <div className="flex items-center gap-2 bg-gray-100 rounded-xl px-3 h-10 border-2 border-transparent focus-within:border-[#0c831f] focus-within:bg-white transition-all shadow-sm">
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-gray-400 shrink-0" aria-hidden="true">
              <path d="m21 21-4.34-4.34" />
              <circle cx="11" cy="11" r="8" />
            </svg>
            <input
              placeholder='Search "atta, milk, eggs..."'
              className="bg-transparent outline-none text-sm text-gray-800 placeholder-gray-400 w-full font-medium"
              type="text"
            />
          </div>
        </div>
      </div>
    </nav>
  );
}